// Carry Roll ConfidenceBadge — Measured/Mixed/Assumed (11.4).

import { useConfidence } from '../../store/selectors';
import { ConfidenceLevel } from '@carry-roll/shared-types';
import { HelpTooltip } from './HelpTooltip';

const META: Record<ConfidenceLevel, { label: string; className: string }> = {
  [ConfidenceLevel.Measured]: { label: 'Measured', className: 'badge-success' },
  [ConfidenceLevel.Mixed]: { label: 'Mixed', className: 'badge-warn' },
  [ConfidenceLevel.Assumed]: { label: 'Assumed', className: 'badge-danger' },
};

export function ConfidenceBadge() {
  const level = useConfidence();
  const meta = META[level];
  return (
    <span className="inline-flex items-center">
      <span
        className={`badge ${meta.className}`}
        data-testid="confidence-badge"
        role="status"
        aria-label={`Confidence: ${meta.label}`}
      >
        {meta.label}
      </span>
      <HelpTooltip label="Confidence">
        Reflects how many key launch inputs were measured by you rather than left at default. Measured = most inputs entered; Assumed = mostly defaults.
      </HelpTooltip>
    </span>
  );
}
